export default "/images/55895d5cb82921b855ed3e215c9a9870.avif";